import React from 'react';
import {withRouter} from "../../../../utils/services/with-router";
import {connect} from "react-redux";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import RequestCard from "./ApprovedRequestCard";
import {Flex} from "antd";
import ApprovedRequestCard from "./ApprovedRequestCard";

const ApprovedRequestList = () => {
    const requests = [
        {
            id: 1,
            title: "دوربین عکاسی",
            requestDate: "یک هفته پیش",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            isApproved:true
        },  {
            id: 2,
            title: "دوربین",
            requestDate: "یک هفته پیش",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            isApproved:true
        },  {
            id: 3,
            title: "دوربین",
            requestDate: "یک هفته پیش",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            isApproved:false
        },  {
            id: 4,
            title: "دوربین",
            requestDate: "یک هفته پیش",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            isApproved:false
        },
    ];
    return (
     <Flex gap={"small"} vertical>
         {requests.map((item: any) => <ApprovedRequestCard detail={item}/>)}
     </Flex>
    );
};


export default connect(null, {})(
    withRouter(ApprovedRequestList)
);
